var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.route == `/provider/members`)?_c('Members'):_vm._e(),(_vm.route == `/provider/members/member`)?_c('Member'):_vm._e(),(_vm.route == `/provider/members/advanced-search`)?_c('Search'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }